import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { DemoButton, Orb, SplitText } from 'components';
import { CONTACT_EMAIL } from 'src/constants/misc';
import { gsap, useGSAP } from 'src/utils/gsap';
import { prefersReducedMotion } from 'src/utils/motion';

import { usePage } from '../../pages';

import style from './Final.module.scss';

const Final = () => {
  const { t } = useTranslation('page');
  const { id } = usePage();
  const sectionRef = useRef(null);

  // The orb returns and grows in as the section scrolls up
  useGSAP(
    () => {
      if (prefersReducedMotion) return;

      gsap.fromTo(
        `.${style.orb}`,
        { scale: 0.7, opacity: 0 },
        {
          scale: 1,
          opacity: 0.75,
          ease: 'none',
          scrollTrigger: { trigger: sectionRef.current, start: 'top bottom', end: 'top 20%', scrub: true }
        }
      );
    },
    { scope: sectionRef }
  );

  return (
    <section
      id='demo'
      ref={sectionRef}
      className={cn('sec tone-dark', style.final)}
      data-tone='dark'
    >
      <Orb
        className={style.orb}
        count={1800}
        scale={0.27}
        glow={0.8}
      />
      <div className={cn('wrap', style.inner)}>
        <SplitText
          as='h2'
          className={style.title}
          reveal
        >
          {t(`${id}.final.title`)} <span className='serif-i accent-v'>{t(`${id}.final.titleAccent`)}</span>
        </SplitText>
        <p className='lead'>{t(`${id}.final.lead`)}</p>
        <div className='cta-row'>
          <DemoButton size='lg'>{t(`${id}.cta`)}</DemoButton>
          <span className={style.mail}>
            {t(`${id}.final.mail`)}{' '}
            <a
              className='sel'
              href={`mailto:${CONTACT_EMAIL}`}
            >
              {CONTACT_EMAIL}
            </a>
          </span>
        </div>
      </div>
    </section>
  );
};

export default Final;
